import Vue from 'vue';
// import Vue from 'vue/dist/vue'; // beacause of bug: with compiler or pre-compiled

import store from './store';
import router from './router';
import globalMixins from './lib/mixins/global-mixins';

import TextContentApp from './TextContentApp';
import Footer from './components/templates/MainFooter';

Vue.mixin(globalMixins);

/* eslint-disable no-new */
new Vue({
  el: '#header',
  components: { TextContentApp },
  replace: false,
  router: router.employer,
  store,
  render: (h) => h(TextContentApp)
});

new Vue({
  el: '#footer',
  components: { Footer },
  replace: false,
  router: router.employer,
  store,
  render: (h) => h(Footer)
});
/* eslint-enable no-new */
